import { useCallback, useRef } from 'react';

const useTimer = (callback: Function) => {
    const timeoutID = useRef();
    const callbackRef = useRef(callback);

    const setTimer = useCallback(
        ms => {
            if (timeoutID.current) {
                clearTimeout(timeoutID.current);
            }
            timeoutID.current = setTimeout(() => callbackRef.current(), ms);
        },
        [callbackRef]
    );

    const clearTimer = useCallback(() => {
        if (timeoutID.current) {
            clearTimeout(timeoutID.current);
        }
    }, []);

    return [setTimer, clearTimer];
};

export default useTimer;
